import React, { useState } from 'react'
import { EventResultsComponent } from './EventResultsComponent'
import { EventResult, ReigniteEventResultsProps } from '../../utils/types'
import ReigniteEventHub from '../../components/shared/ReigniteEventHub'
import { HttpStatusCode } from 'axios'

export function ReigniteEventLeaderboardResults(props: ReigniteEventResultsProps) {
  const ctliveEventId = props.master?.event?.ctliveId
  const ctliveRaceId = props.schedule?.find(schedule =>
    schedule.athlinksCourseId === props.races?.races?.find(
      race => race.eventCourseId === props.eventResultsFilters.course
    )?.courseId
  )?.raceId
  const athlinksEventId = props.eventResultsFilters.date
  const eventCourseId = props.eventResultsFilters.course
  const divisionId = props.eventResultsFilters.division
  const from = (props.page || props.eventResults.args.fro) * props.eventResults.args.limit
  const limit = props.eventResults.args.limit
  const [data, setData] = useState<EventResult[]>([])
  const [asOf, setAsOf] = useState(Date.now())
  const [fetchEventResultsError, setFetchEventResultsError] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const onMessage = React.useCallback((parsed: { data: EventResult[], status: HttpStatusCode }) => {
    if (Array.isArray(parsed.data) && parsed.status === HttpStatusCode.Ok) {
      setData(parsed.data)
      setFetchEventResultsError(false)
    } else {
      setFetchEventResultsError(true)
    }
  }, [])
  const updateIsLoading = React.useCallback((value: boolean) => {
    setIsLoading(value)
  }, [])

  return (
    <>
      <ReigniteEventHub
        onMessage={onMessage}
        updateIsLoading={updateIsLoading}
        params={{
          asOf,
          athlinksEventId,
          ctliveEventId,
          ctliveRaceId,
          divisionId,
          eventCourseId,
          from,
          limit,
        }}
      />
      <EventResultsComponent
        {...props}
        fetchEventResultsError={fetchEventResultsError}
        eventResults={{ data, isLoading }}
        refetch={() => setAsOf(Date.now())}
        useSse={true}
      />
    </>
  )
}
